// API 基础URL
export const BASE_URL = '/api';
// 速问前端平台 API 域名
export const SW_WEB_BASE_URL = 'https://portal.suwendata.com/api';

/**
 * @description - 登录接口 (通过Vite代理转发到速问平台)
 */
export const LOGIN_URL = `${BASE_URL}/auth/login`;

/**
 * @description - 获取用户Key列表
 */
export const GET_USER_KEYS_URL = `${BASE_URL}/user-key/get-user-key`;

/**
 * @description - 删除用户Key
 */
export const DELETE_USER_KEY_URL = `${BASE_URL}/user-key/delete-user-keys`;

/**
 * @description - 创建用户Key
 */
export const CREATE_USER_KEY_URL = `${BASE_URL}/user-key/create-user-key`;